const GoodsEnum = Object.freeze({
    product: "model",
    certificate: "certificate"
});

export default GoodsEnum;